import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

export const getAreasEje = query =>
	fetch.get(
		`/areas-eje${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getAreaEje = ({ id, query }) =>
	fetch.get(`/areas-eje/${id}${
		query
			? `?${qs.stringify(
					{ ...query, publicationState: 'live' },
					{
						encodeValuesOnly: true,
					}
			  )}`
			: ''
	}
}`);
export const addAreaEje = data => fetch.post('/areas-eje', data);
export const updateAreaEje = ({ id, ...data }) =>
	fetch.put(`/areas-eje/${id}`, data);
export const deleteAreaEje = id => fetch.delete(`/areas-eje/${id}`);

// RTK Query
export const areasEjeApi = createApi({
	reducerPath: 'areasEjeApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getAreasEje: build.query({
			query: query => {
				return {
					url: `/areas-eje${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'AreasEje',
								id,
							})),
							{ type: 'AreasEje', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'AreasEje', id: 'LIST' }],
		}),
		getAreaEje: build.query({
			query: ({ id, query }) => {
				return {
					url: `/areas-eje/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'AreasEje', id }],
		}),
		addAreaEje: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/areas-eje`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Area Ejecución agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar area ejecución');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'AreasEje', id: 'LIST' }],
		}),
		updateAreaEje: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/areas-eje/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Area Ejecución actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar area ejecución');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [{ type: 'AreasEje', id }],
		}),
		deleteAreaEje: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/areas-eje/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Area Ejecución eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar area ejecución');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [{ type: 'AreasEje', id }],
		}),
	}),
});

export const {
	useGetAreasEjeQuery,
	useGetAreaEjeQuery,
	useAddAreaEjeMutation,
	useUpdateAreaEjeMutation,
	useDeleteAreaEjeMutation,
} = areasEjeApi;
